module.exports = __webpack_public_path__ + "static/img/5areaB_10.f9c1a43.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_10.png
// module id = 1200
// module chunks = 1